export default __webpack_public_path__ + "static/rachel_bw-12f54af8075b32ff548e4d70c8326d73.jpeg";